import { faker } from '@faker-js/faker';
import { define } from 'cooky-cutter';
import { PermissionsGroup, PermissionsGroupUserRoleAssignment } from '../types';
import { permissionsGroupNames } from './permissions';
import { userRoleAssignmentFactory } from './user-role-assignment';

export const permissionsGroupFactory = define<PermissionsGroup>({
  id: () => faker.string.uuid(),
  name: () => faker.helpers.arrayElement(permissionsGroupNames),
});

export const permissionsGroupUserRoleAssignmentFactory =
  define<PermissionsGroupUserRoleAssignment>({
    id: () => faker.string.uuid(),
    permissionsGroup: () => permissionsGroupFactory(),
    createdAt: () => faker.date.recent(),
    userRoleAssignment: () => userRoleAssignmentFactory(),
    active: () => faker.datatype.boolean(),
  });
